import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Sidebar } from "./components/shell/Sidebar";
import { Topbar } from "./components/shell/Topbar";
import { DashboardScreen } from "./features/dashboard/DashboardScreen";
import { UsersScreen } from "./features/users/UsersScreen";
import { ReferralScreen } from "./features/placeholders/ReferralScreen";
import { CampaignsScreen } from "./features/placeholders/CampaignsScreen";
import { SettingsScreen } from "./features/placeholders/SettingsScreen";
import { AdminControlsProvider } from "./state/AdminControlsContext";
import "./App.css";

/**
 * Global shell (sidebar + topbar + routed content). The Topbar controls
 * (time-range toggle, search) and the routed screens share state via
 * AdminControlsProvider. Dashboard/Users are the V1 screens; Kampagnen /
 * Referral / Settings placeholders land with FE-6/7.
 */
const App: React.FC = () => {
  return (
    <AdminControlsProvider>
      <div className="shell">
        <Sidebar />
        <div className="shell-main">
          <Topbar />
          <main className="shell-content">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardScreen />} />
              <Route path="/users" element={<UsersScreen />} />
              {/* User detail deep-link reserved for a later phase */}
              <Route path="/users/:id" element={<UsersScreen />} />
              <Route path="/campaigns" element={<CampaignsScreen />} />
              <Route path="/referral" element={<ReferralScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </main>
        </div>
      </div>
    </AdminControlsProvider>
  );
};

export default App;
